// src/features/legal/pages/LegalPrivacyPage.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../legal.css";
import { SPC_MODEL, getDeviceModel } from "@/lib/androidBridge";

const withBase = (p: string) => (import.meta.env.BASE_URL || "./") + p.replace(/^\/+/, "");
const ICONS = {
    first: withBase("icons/prev2.svg"),
    prev:  withBase("icons/prev1.svg"),
    next:  withBase("icons/next1.svg"),
    last:  withBase("icons/next2.svg"),
};

const SECTIONS = [
    {
        title: "제1조 (개인정보의 처리 목적)",
        body: "회사는 다음의 목적을 위하여 개인정보를 처리하며, 해당 목적 이외의 용도로는 이용하지 않습니다.\n\n회원관리\n· 회원 가입 및 본인 확인\n· 계정 관리 및 서비스 이용 지원\n· 부정 이용 방지 및 중복 가입 방지\n\n서비스 제공\n· 독서 기록 및 리뷰 기능 제공\n· 콘텐츠 저장 및 관리\n· 개인화 콘텐츠 추천\n\n서비스 개선 및 분석\n· 이용 패턴 분석\n· 서비스 품질 개선 및 신규 기능 개발\n\n고객 지원\n· 문의 및 불만 처리\n· 공지사항 전달\n\n마케팅 및 광고 활용 (선택 동의 시)\n· 이벤트 및 혜택 안내\n· 신규 기능 및 콘텐츠 안내",
    },
    {
        title: "제2조 (처리하는 개인정보 항목)",
        body: "회사는 최소한의 개인정보를 수집합니다.\n\n1. 회원가입 시\n· 로그인 정보 (비밀번호 또는 소셜 로그인 식별값)\n· 전화번호, 성별, 생년월일\n\n2. 서비스 이용 과정에서 생성되는 정보\n· 독서 기록 (책, 날짜, 메모 등)\n· 리뷰, 별점, 키워드\n· 서비스 이용 기록 (접속 로그, 이용 시간 등)\n\n3. 자동 수집 정보\n· 기기 정보 (OS, 기기 모델 등)\n· 로그 데이터",
    },
    {
        title: "제3조 (개인정보의 보유 및 이용기간)",
        body: "개인정보는 목적 달성 시까지 보유합니다.\n\n회원 탈퇴 시 즉시 삭제합니다.\n\n다만, 아래의 경우 일정 기간 보관할 수 있습니다:\n· 법령에 따른 보관 의무\n· 부정 이용 방지 (최대 30일)\n· 분쟁 해결 및 증빙",
    },
    {
        title: "제4조 (만 14세 미만 아동의 개인정보 처리)",
        body: "만 14세 미만 아동의 경우 법정대리인의 동의를 받아야 합니다.\n\n법정대리인은 아동의 개인정보에 대해 열람, 수정, 삭제를 요청할 수 있습니다.",
    },
    {
        title: "제5조 (개인정보의 제3자 제공)",
        body: "회사는 이용자의 개인정보를 외부에 제공하지 않습니다.\n\n다만, 다음의 경우 예외로 합니다:\n· 이용자의 사전 동의가 있는 경우\n· 법령에 따른 경우",
    },
    {
        title: "제6조 (개인정보 처리의 위탁)",
        body: "회사는 서비스 제공을 위해 일부 업무를 외부에 위탁할 수 있습니다.\n· 클라우드 서버 (AWS, GCP 등)\n· 데이터 분석 도구\n· 알림 발송 서비스\n\n회사는 위탁업체가 개인정보를 안전하게 처리하도록 관리·감독합니다.",
    },
    {
        title: "제7조 (개인정보의 파기)",
        body: "회사는 개인정보 보유기간 경과 또는 처리 목적 달성 시 지체 없이 파기합니다.\n\n1. 파기 절차\n· 목적 달성 후 즉시 삭제\n\n2. 파기 방법\n· 전자 파일: 복구 불가능한 방법으로 삭제\n· 종이 문서: 분쇄 또는 소각",
    },
    {
        title: "제8조 (이용자의 권리 및 행사 방법)",
        body: "이용자는 언제든지 다음 권리를 행사할 수 있습니다:\n· 개인정보 열람\n· 개인정보 수정\n· 개인정보 삭제\n· 처리 정지\n· 동의 철회\n\n아래 고객지원 센터를 통해 요청할 수 있습니다.\n\n이노스페이스원 고객지원 센터\n-이메일 : cs_as@innowaveglobal.com\n-전화번호 : 031-689-4548\n-운영시간 : 평일 10:00~17:30 (주말 및 공휴일 제외)",
    },
    {
        title: "제9조 (개인정보의 안전성 확보 조치)",
        body: "회사는 개인정보 보호를 위해 다음과 같은 조치를 취합니다:\n· 데이터 암호화\n· 접근 권한 관리\n· 보안 시스템 운영\n· 내부 관리계획 수립",
    },
    {
        title: "제10조 (개인정보 자동 수집 장치의 운영)",
        body: "회사는 쿠키를 사용하여 서비스를 제공합니다.\n\n쿠키 사용 목적\n· 로그인 유지\n· 이용자 맞춤 서비스 제공\n· 서비스 이용 분석",
    },
    {
        title: "제11조 (개인정보 보호책임자)",
        body: "회사는 개인정보 보호를 위해 아래와 같이 책임자를 지정합니다:\n관리부서 : 기술 연구소\n담당자 : 유왕재",
    },
    {
        title: "제12조 (권익침해 구제방법)",
        body: "이용자는 개인정보 침해에 대해 아래 기관에 문의할 수 있습니다:\n· 개인정보침해신고센터 (privacy.kisa.or.kr / 118)\n· 개인정보분쟁조정위원회 (kopico.go.kr / 1833-6972)",
    },
    {
        title: "제13조 (개인정보처리방침의 변경)",
        body: "본 방침은 관련 법령 및 서비스 변경에 따라 수정될 수 있으며, 변경 시 사전 공지합니다.",
    },
];

// 제1조가 길어서 첫 페이지만 1개, 이후 2개씩
const PAGE_SPLITS = [1, 2, 3, 2, 3, 2];

const PAGE_RANGES: [number, number][] = (() => {
    const ranges: [number, number][] = [];
    let idx = 0;
    for (let i = 0; i < PAGE_SPLITS.length; i++) {
        const end = i === PAGE_SPLITS.length - 1
            ? SECTIONS.length
            : idx + PAGE_SPLITS[i];
        ranges.push([idx, end]);
        idx = end;
    }
    return ranges;
})();

function renderBody(text: string) {
    return text.split("\n").map((line, i, arr) => (
        <React.Fragment key={i}>
            {line}
            {i < arr.length - 1 && <br />}
        </React.Fragment>
    ));
}

const isSpc = getDeviceModel() === SPC_MODEL;

export default function LegalPrivacyPage() {
    const nav = useNavigate();
    const [page, setPage] = useState(1);

    const totalPages = PAGE_RANGES.length;
    const isLast = page === totalPages;
    const hasNext = page < totalPages;
    const [start, end] = PAGE_RANGES[page - 1];
    const visible = SECTIONS.slice(start, end);

    const handleAgree = () => {
        nav("/auth/agree", { state: { agreed: "privacy" }, replace: true });
    };

    return (
        <div className={isSpc ? "legal-page legal-page--spc" : "legal-page"}>
            <h1>개인정보처리방침</h1>

            <div className="legal-content">
                {visible.map((sec) => (
                    <React.Fragment key={sec.title}>
                        <h2>{sec.title}</h2>
                        <p>{renderBody(sec.body)}</p>
                    </React.Fragment>
                ))}
            </div>

            {/* 고정 하단 푸터: 동의 버튼 + 페이저 */}
            <div className="legal-fixed-footer">
                {isLast && (
                    <div className="legal-agree-footer">
                        <button className="legal-agree-btn" onClick={handleAgree}>동의</button>
                    </div>
                )}
                <div className="legal-pager">
                <button
                    className="legal-pager-btn"
                    disabled={page <= 1}
                    onClick={() => setPage(1)}
                    aria-label="처음"
                >
                    <img src={ICONS.first} alt="" />
                </button>
                <button
                    className="legal-pager-btn"
                    disabled={page <= 1}
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    aria-label="이전"
                >
                    <img src={ICONS.prev} alt="" />
                </button>
                <span className="legal-pager-label">{page} / {totalPages}</span>
                <button
                    className="legal-pager-btn"
                    disabled={!hasNext}
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    aria-label="다음"
                >
                    <img src={ICONS.next} alt="" />
                </button>
                <button
                    className="legal-pager-btn"
                    disabled={!hasNext}
                    onClick={() => setPage(totalPages)}
                    aria-label="마지막"
                >
                    <img src={ICONS.last} alt="" />
                </button>
                </div>
            </div>
        </div>
    );
}